const resources = {
  "en": {
    "accountDeletionConfirm": {
      "title": "Confirm account deletion",
      "verifying": "Confirming your deletion request…",
      "successTitle": "Your account has been deleted",
      "successDescription": "Open FinApp again and you’ll be asked to sign in. If this page opened from email instead of the iOS app, the app will detect the deleted session on the next protected request.",
      "processingTitle": "Deletion is still processing",
      "processingDescription": "We received the confirmation, but cleanup has not finished yet. Try again in a moment.",
      "errorTitle": "Unable to confirm the request",
      "errorDescription": "The confirmation link may have expired or was already used. Try again below.",
      "missingTitle": "Missing confirmation details",
      "missingDescription": "Open the link from your email so we can read the token and email parameters.",
      "retry": "Retry confirmation",
      "backToLogin": "Back to login"
    }
  },
  "uk": {
    "accountDeletionConfirm": {
      "title": "Підтвердження видалення акаунта",
      "verifying": "Підтверджуємо ваш запит на видалення…",
      "successTitle": "Ваш акаунт видалено",
      "successDescription": "Відкрийте FinApp знову, і застосунок попросить увійти. Якщо ця сторінка відкрилась з email замість iOS застосунку, застосунок побачить видалену сесію під час наступного захищеного запиту.",
      "processingTitle": "Видалення ще виконується",
      "processingDescription": "Ми отримали підтвердження, але очищення ще не завершилось. Спробуйте ще раз за мить.",
      "errorTitle": "Не вдалося підтвердити запит",
      "errorDescription": "Можливо, посилання підтвердження застаріло або вже використане. Спробуйте ще раз.",
      "missingTitle": "Відсутні дані для підтвердження",
      "missingDescription": "Відкрийте посилання з листа, щоб передати токен і email.",
      "retry": "Спробувати ще раз",
      "backToLogin": "Повернутися до входу"
    }
  }
};

export default resources;
